/* eslint-disable func-names */
import { zonedTimeToUtc, format } from 'date-fns-tz';
import parseISO from 'date-fns/parseISO';
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const helpers = {
  install(Vue, options) { // eslint-disable-line

    Vue.prototype.$navigateTo = function ({ path, name, newTab, externalUrl, query }) {
      if (externalUrl) {
        let url = externalUrl;
        if (url.substring(0, 4) !== 'http') url = `https://${url}`;

        window.open(url, '_blank');
        return;
      }

      let destination;
      if (path) destination = { path, query };
      else if (name) destination = { name };

      if (!newTab) this.$router.push(destination).catch(() => { });
      else {
        const route = this.$router.resolve(destination);
        window.open(route.href, '_blank');
      }

      // If search is active, hide the view (doubled in the $navigateTo helper, think I can delete this one but still need to doublecheck)
      if (this.$store.state.appState.search.isActive) this.$store.dispatch('appState/setSearchState', { displayResults: false });
    };

    Vue.prototype.$goToCard = function ({ id, relatedCollectionId }) {
      if (!id && id !== 0) return;

      if (relatedCollectionId) this.$navigateTo({ path: `/${relatedCollectionId}/card/${id}` });
      else this.$navigateTo({ path: `/card/${id}` });
    };

    Vue.prototype.$addKeywordToList = function (keyword) {
      const { lastKeywordList } = this.$store.state.appState;
      if (!lastKeywordList) {
        this.$navigateTo({ path: `/keyword/${keyword}` });
        return;
      }

      // We already have a keywordList, get current keywords and add new keyword
      const path = `${lastKeywordList}/${keyword}`;
      this.$navigateTo({ path });
    };

    Vue.prototype.$removeKeywordFromList = function (keyword) {
      // Note: if the last keyword is removed, 'path' becomes '/keyword' which vue-router automatically redirects to selectedCollection (accidentally, but it's perfect)
      let { path } = this.$route;
      const index = path.indexOf(`/${keyword}`);
      const length = keyword.length + 1; // Account for forward slash in path
      path = `${path.substring(0, index)}${path.substring(index + length)}`;

      // If we just removed the last keyword from the list, Vuex needs to be updated here since addNavigationToHistory won't do that for us
      if (path === '/keyword') {
        this.$store.commit('appState/SaveKeywordList', null);
        // Path should be the last non-keywordlist page in navigationHistory
        path = this.$store.state.appState.navigationHistory.find(val => !val.includes('/keyword'));
      }

      this.$navigateTo({ path });
    };

    Vue.prototype.$addStarToList = function (stars) {
      const { lastStarList } = this.$store.state.appState;
      if (!lastStarList) {
        this.$navigateTo({ path: `/stars/${stars}` });
        return;
      }

      // We already have a starList, get current stars and add new one
      const path = `${lastStarList}/${stars}`;
      this.$navigateTo({ path });
    };

    Vue.prototype.$removeStarFromList = function (stars) {
      // Note: if the last star is removed, 'path' becomes '/stars' which vue-router automatically redirects to selectedCollection (accidentally, but it's perfect)
      let { path } = this.$route;
      const index = path.indexOf(`/${stars}`);
      path = `${path.substring(0, index)}${path.substring(index + 2)}`;

      // If we just removed the last star from the list, Vuex needs to be updated here since addNavigationToHistory won't do that for us
      if (path === '/stars') {
        this.$store.commit('appState/SaveStarList', null);
        // Path should be the last non-starlist page in navigationHistory
        path = this.$store.state.appState.navigationHistory.find(val => !val.includes('/stars'));
      }

      this.$navigateTo({ path });
    };

    Vue.prototype.$goToItem = function ({ id, relatedCollectionId }) {
      if (!id) return;

      if (relatedCollectionId) this.$navigateTo({ path: `/${relatedCollectionId}/item/${id}` });
      else this.$navigateTo({ path: `/item/${id}` });
    };

    Vue.prototype.$goToNote = function ({ id, relatedCollectionId }) {
      if (!id) return;

      if (relatedCollectionId) this.$navigateTo({ path: `/${relatedCollectionId}/note/${id}` });
      else this.$navigateTo({ path: `/note/${id}` });
    };

    Vue.prototype.$goToCollection = function ({ id }) {
      const path = `/collection/${id}`;
      this.$navigateTo({ path });
    };

    Vue.prototype.$navigateViaHelper = function ({ path }) {
      // This function is used in ItemView, when closing the last file in WebViewer. I just have no clue why, I should be able to pass a path
      // directly to $navigateTo without this intermediary function. Path in ItemView comes from navigationHistory, maybe that has something to do with it.
      let type;
      let id;
      let relatedCollectionId;
      // let tab;

      const splitPath = path.split('/');
      if (splitPath.length === 3) [, type, id] = splitPath;
      else if (splitPath.length === 4 && splitPath[1] !== 'collection') [, relatedCollectionId, type, id] = splitPath;
      else if (splitPath.length === 4) [, type, id] = splitPath;
      else {
        // Not sure what this navigation could be, just try going there
        this.$navigateTo({ path });
        return;
      }

      if (type === 'note') this.$goToNote({ id, relatedCollectionId });
      // else if (type === 'cards' || type === 'cards') this.$goToCollection({ id, tab });
      else if (type === 'card') this.$goToCard({ id, relatedCollectionId });
      else if (type === 'item') this.$goToItem({ id, relatedCollectionId });
      else this.$goToCollection({ id });
    };

    Vue.prototype.$getCurrentUTC = function () {
      return zonedTimeToUtc(new Date(), timezone).toISOString();
    };

    Vue.prototype.$formatDate = function (date) {
      // It does not seem necessary to use utcToZonedTime here, both return the local time (though it you want to allow user settings with timezones, you'll need it)
      if (typeof date === 'string') return format(parseISO(date), 'MMMM dd, yyyy (HH:mm)');
      if (typeof date === 'undefined') return null;
      return format(date, 'MMMM dd, yyyy @ HH:mm');
    };

    Vue.prototype.$formatDateConcise = function (date) {
      // It does not seem necessary to use utcToZonedTime here, both return the local time (though it you want to allow user settings with timezones, you'll need it)
      if (typeof date === 'string') return format(parseISO(date), 'dd/MM/yyyy HH:mm');
      if (typeof date === 'undefined') return null;
      return format(date, 'dd/MM/yyyy HH:mm');
    };

    Vue.prototype.$clearFormattingOnPaste = function (e) {
      e.preventDefault();
      let text = '';
      if (e.clipboardData || e.originalEvent.clipboardData) {
        text = (e.originalEvent || e).clipboardData.getData('text/plain');
      }
      else if (window.clipboardData) {
        text = window.clipboardData.getData('Text');
      }

      text = text.replace(/(\r\n\t|\n|\r\t)/gm, ''); // to do: might not be the most efficient regexp operation, but it works

      if (document.queryCommandSupported('insertText')) {
        document.execCommand('insertText', false, text);
      }
      else {
        document.execCommand('paste', false, text);
      }
    };

    /**
     * This function allow you to modify a JS Promise by adding some status properties.
     * Based on: http://stackoverflow.com/questions/21485545/is-there-a-way-to-tell-if-an-es6-promise-is-fulfilled-rejected-resolved
     * But modified according to the specs of promises : https://promisesaplus.com/
     */
    Vue.prototype.$getQuerablePromise = function (promise) {
      // Don't modify any promise that has been already modified.
      if (promise.isResolved) return promise;

      // Set initial state
      let isPending = true;
      let isRejected = false;
      let isFulfilled = false;

      // Observe the promise, saving the fulfillment in a closure scope.
      const result = promise.then(
        function (v) { // eslint-disable-line
          isFulfilled = true;
          isPending = false;
          return v;
        },
        function (e) { // eslint-disable-line
          isRejected = true;
          isPending = false;
          throw e;
        },
      );

      result.isFulfilled = function () { return isFulfilled; };
      result.isPending = function () { return isPending; };
      result.isRejected = function () { return isRejected; };
      return result;
    };

    // VUEX HELPERS
    Vue.prototype.$updateCard = function ({ id, data }) {
      this.$store.dispatch('cards/modifyCards', {
        cards: [{
          action: 'update',
          id,
          data,
        }],
      });
    };
    Vue.prototype.$deleteCard = function (id) {
      this.$store.dispatch('cards/modifyCards', {
        cards: [{
          action: 'delete',
          id,
        }],
      });
    };
    Vue.prototype.$addKeyword = function ({ id, keyword }) {
      this.$store.dispatch('cards/modifyCards', {
        keywords: [{
          action: 'add',
          id,
          keyword,
        }],
      });
    };
    Vue.prototype.$deleteKeyword = function ({ id, keyword }) {
      this.$store.dispatch('cards/modifyCards', {
        keywords: [{
          action: 'delete',
          id,
          keyword,
        }],
      });
    };
    Vue.prototype.$addRelatedCard = function ({ ids, note }) {
      this.$store.dispatch('cards/modifyCards', {
        relatedCards: [{
          action: 'add',
          ids,
          note,
        }],
      });
    };
    Vue.prototype.$updateRelatedCard = function ({ ids, note }) {
      this.$store.dispatch('cards/modifyCards', {
        relatedCards: [{
          action: 'update',
          ids,
          note,
        }],
      });
    };
    Vue.prototype.$deleteRelatedCard = function (ids) {
      this.$store.dispatch('cards/modifyCards', {
        relatedCards: [{
          action: 'delete',
          ids,
        }],
      });
    };
  },
};

export default helpers;
